/* Base translations · Risk assessment — moved unchanged out of lib/i18n.js (STEP 6 · split 6f).
   Top-level keys owned by this file (no other base file and not i18n.js define them): risk. */
export const I18N_BASE_RISK = {
  en: {
    risk: {
      title: "Risk Assessment",
      subtitle: "Materiality and general risk assessment (ISA 315). Fraud risk (ISA 240) lives in Fieldwork → Journal Entry Testing and Fraud Red Flags.",
      materialityTitle: "Materiality (ISA 320 / 450)",
      materialityDesc: "Overall materiality is applied to the financial statements as a whole; performance materiality is applied to sampling and specific tests. The overall materiality set here automatically drives the Sampling module.",
      overall: "Overall materiality",
      performance: "Performance materiality",
      clearlyTrivial: "Clearly trivial threshold",
      saveMateriality: "Save materiality",
      materialityEditIn105a: "Edit in 105(a) Materiality",
      materialityNotSet: "Not set in 105(a)",
      materialityReadOnlyNote: "Materiality figures are read from Form 105(a) — the single source. Edit them in 105(a) Materiality.",
      generalTitle: "General Risk Assessment (ISA 315)",
      aiSuggestBtn: "AI Suggest risks",
      aiSuggestHint: "AI drafts risks from your TB + account areas. Review each row and tap Accept to add it to the register.",
      aiSuggestEmpty: "The AI didn't return any draft risks for this engagement.",
      aiSuggestAccept: "Accept",
      aiSuggestAcceptAll: "Accept all",
      aiSuggestDiscard: "Discard",
      aiSuggestLoading: "AI is drafting risks…",
      aiSuggestFailedMsg: "AI suggest failed. Try again shortly.",
      aiSuggestConfidence: "Confidence",
      aiSuggestSource: "Source",
      aiSuggestStatus: "Status",
      aiSuggestEmptyTb: "No trial balance is loaded for this engagement, so there is nothing to draft risks from. Upload the TB first.",
      aiSuggestQueued: "Request queued — drafting risks from your TB, prior-year risks and the procedure library…",
      riskLibraryBtn: "Risk library",
      aiSuggestEdit: "Edit", aiSuggestReject: "Reject", aiSuggestEditTitle: "Edit draft before accepting",
      aiSuggestAcceptSave: "Accept into register", aiSuggestLinked: "Linked procedures",
      riskLibraryHint: "Standard ISA 315 starter risks (not generated for this engagement). Review each row and tap Accept to add it to the register.",
      addRisk: "Add risk",
      fsArea: "FS area",
      assertion: "Assertion",
      riskDesc: "Risk description",
      inherent: "Inherent",
      control: "Control",
      likelihood: "Likelihood",
      impact: "Impact",
      overallRating: "Overall",
      response: "Planned response",
      fraudTitle: "Fraud Risk Fingerprints (ISA 240)",
      fraudDesc: "Automatically scanned across the current-period GL. Every finding is a red-flag pattern — review whether it is explained or requires further audit work.",
      cutoffTitle: "Cut-off Testing — first 5 & last 5 entries",
      cutoffDesc: "Auto-picked entries around the period boundary (ISA 315). Test these to ensure correct-period recognition.",
      first: "First 5 entries",
      last: "Last 5 entries",
      tabs: {
        materiality: "Materiality",
        general: "General Risk (ISA 315)",
        fraud: "Fraud Risk (ISA 240)",
        cutoff: "Cut-off",
      },
      tableEmpty: "No risk items yet. Add your first ISA 315 risk to build the assessment.",
      edit: "Edit",
      saveRisk: "Save risk",
      editRisk: "Edit risk",
      saveChanges: "Save changes",
      attachLabel: "Supporting documents for this risk entry",
      // L2 — Risk \u2192 Procedure link (round 01-Oct-2026).
      linkedProceduresLabel: "Linked audit procedures",
      linkedProceduresHelp: "Pick one or more procedures from this engagement's library that respond to this risk. Suggested procedures are pre-selected based on the FS area.",
      linkedProceduresNone: "None linked",
      linkedProceduresSuggested: "Suggested for {area}",
      linkedProceduresAll: "All procedures",
      linkedProceduresCount: "{n} linked",
      linkedProceduresPickBtn: "Link procedures",
      linkedProceduresEmpty: "Procedure library has no entries for this engagement.",
      linkedProceduresLoadError: "Could not load the procedure library.",
      refColLinked: "Linked procedures",
      // M3l · Item 36 — Recycle Bin.
      bin: {
        title: "Recycle Bin",
        subtitle: "Items stay 30 days, engagements 60 days; locked engagements are kept.",   // Batch 16 · Q12: each rule said once
        colType: "Type", colName: "Name / ref", colEng: "Engagement",
        colDeletedBy: "Deleted by", colDeletedAt: "When",
        colReason: "Reason", colDaysLeft: "Days left",
        colActions: "",
        restore: "Restore",
        restoreOk: "Restored",
        restoreFail: "Restore failed",
        empty: "The recycle bin is empty.",
        tabDeleted: "Deleted items",
        tabArchived: "Archived engagements",
        restoreForbidden: "Only Partner / Director / Manager / Admin may restore.",
        windowDays: "{n}-day window",
        // Batch 14 · M16 — engagements: 60 days, permanent delete by Partner / Director / Admin, one-time code within 30 days
        engagementWindow: "Permanent delete of an engagement: the firm's Partner, Director or Admin; within 30 days of the deletion a one-time code to your e-mail plus the engagement name typed, after 30 days the typed name only. Every permanent delete is kept on the Audit Trail.",
        permanent: "Delete permanently", permanentTitle: "Delete this engagement permanently?",
        permanentBody: "{name} · {days} day(s) in the bin. This cannot be undone. Type the engagement name to confirm.",
        permanentOtp: "A fresh one-time code will be sent to your e-mail (the engagement was deleted less than 30 days ago).",
        permanentNoOtp: "More than 30 days in the bin — the typed name is enough.",
        permanentConfirm: "Delete permanently", permanentDone: "Engagement permanently deleted", permanentNameMismatch: "Type the engagement name exactly as shown.",
        purgeDryRun: "The daily cleaner is in dry-run mode: nothing is removed yet; items past their window stay hidden until the cleaner is switched on.",
        purgeActive: "The daily cleaner removes items once their window ends.",
        daysLeftRule: "Days left = floor(window − time since delete) in whole days. At 0 the daily cleaner removes the item.",
        type: {
          attachment: "Attachment",
          risk: "Risk register entry",
          misstatement: "Misstatement",
          w17_likely_area: "W17 likely area",
          gl_head_upload: "GL head upload",
          vouching_work_done_line: "Vouching work-done line",
          vouching_items: "Vouching line",
          engagement_archived: "Archived engagement",
          engagement: "Engagement (deleted)",
          form_state: "Form answers",
          sample: "Sample",
          deficiency: "Control deficiency",
          form_attachment: "Supporting file",
          unknown: "Other",
        },
      },
      procRisks: {
        title: "Risks this procedure responds to",
        empty: "No risk linked to this procedure yet.",
        noLinked: "No linked risk",
      },
      refreshing: "Refreshing…",
      refresh: "Refresh",
      refreshBold: "Refresh",
      scanning: "Scanning…",
      fraudRunning: "Running fraud fingerprint scan across the current-period GL…",
      fraudLoadError: "Could not load fraud scan",
      fraudRetryHint: "Click {refreshBold} above to retry.",
      fraudEmptyTitle: "No GL entries to scan",
      fraudEmptyBody: "This engagement has 0 current-period GL entries. Import a GL from {linkItalic} to run fraud fingerprints.",
      fraudEmptyLink: "Fieldwork → GL Import",
      dataQualityNotes: "Data-quality notes",
      largeResultSetBold: "Large result set —",
      largeResultSetBody: "some fingerprints exceeded the 500-row cache limit and are showing the first {n} hits. Count badges still reflect the true total. Use the XLSX export on any group to download every flagged row.",
      populationLabel: "Population:",
      populationSuffix: "current-period GL entries",
      cappedTitle: "Count was capped at the population size — a fingerprint should never exceed the total GL entries.",
      cappedBadge: "capped",
      cutoffCardTitle: "Cut-off (ISA 315) — First/Last",
      cutoffCacheEmpty: "No cut-off scan cached yet. Click Refresh to run it on the worker fleet.",
      cutoffRunning: "Cut-off scan running on the worker fleet…",
      cutoffCached: "Cached",
      cutoffStale: "(stale — GL changed)",
      showingPre: "Showing",
      showingMid: "of",
      showingSuffix: "flagged transactions",
      truncatedByServer: "— list truncated by the server",
      colDate: "Date",
      colVoucherAccount: "Voucher / Account",
      colAmount: "Amount",
      colReason: "Reason",
      colVoucher: "Voucher",
      colAccount: "Account",
      noVoucher: "(no voucher)",
      openGlEntryTitle: "Open GL entry in a new tab",
      testTheseNow: "Test these now",
      testTheseNowTitle: "Open Sampling with Continuous testing pre-selected for this fingerprint",
      downloadXlsxTitle: "Download all {n} flagged transactions as XLSX",
      exportSuccess: "Exported {n} flagged transactions",
      exportFailed: "Export failed",
      selectEngFirst: "Select an engagement first",
      toasts: {
        fraudAlreadyRunning: "A fraud scan is already running for this engagement — polling…",
        fraudQueued: "Fraud scan queued — results will appear shortly.",
        fraudEnqueueFailed: "Failed to enqueue fraud scan.",
        fraudLoadFailed: "Failed to load fraud scan.",
        cutoffAlreadyRunning: "A cut-off scan is already running for this engagement — polling…",
        cutoffQueued: "Cut-off scan queued.",
        cutoffEnqueueFailed: "Failed to enqueue cut-off scan.",
        materialitySaved: "Materiality saved — Sampling and every linked screen now show these values",
        saveFailed: "Save failed",
        riskAdded: "Risk added",
        addFailed: "Failed",
        deleteFailed: "Delete failed",
        riskUpdated: "Risk updated",
        updateFailed: "Update failed",
      },
      nwd: {
        title: "Non-working days (weekends + public holidays)",
        desc: "Drives the {weekendBold} fingerprint here, the Analytics weekend flags, and the Sampling risk-based scorer. Historical scans are not rewritten — click {refreshBold} above to re-scan after saving.",
        weekendBold: "Weekend / after-hours",
        refreshBold: "Refresh",
        weekendDays: "Weekend days",
        publicHolidays: "Public holidays",
        noHolidays: "No holidays configured.",
        cannotAllNonWorking: "Cannot mark every day non-working.",
        saved: "Non-working days saved. Click Refresh above to re-scan.",
        add: "Add",
        save: "Save",
        days: {
          mon: "Mon",
          tue: "Tue",
          wed: "Wed",
          thu: "Thu",
          fri: "Fri",
          sat: "Sat",
          sun: "Sun",
        },
      },
    },
  },
  ar: {
    risk: {
      title: "تقييم المخاطر",
      subtitle: "الأهمية النسبية وتقييم المخاطر العام \u2066(ISA 315)\u2069. يُعالج تقييم مخاطر الاحتيال \u2066(ISA 240)\u2069 ضمن تبويب أعمال الميدان ← اختبار قيود اليومية ومؤشرات الاحتيال.",
      materialityTitle: "الأهمية النسبية \u2066(ISA 320 / 450)\u2069",
      materialityDesc: "تُطبق الأهمية النسبية الكلية على القوائم المالية ككل؛ وتُطبق الأهمية النسبية للأداء على العينات والاختبارات المحددة. الأهمية النسبية الكلية المحددة هنا تُغذي وحدة العينات تلقائياً.",
      overall: "الأهمية النسبية الكلية",
      performance: "الأهمية النسبية للتنفيذ",
      clearlyTrivial: "الحد الأدنى للمبلغ التافه بوضوح",
      saveMateriality: "حفظ الأهمية النسبية",
      materialityEditIn105a: "التعديل في نموذج 105(a) الأهمية النسبية",
      materialityNotSet: "لم تُحدد في نموذج 105(a)",
      materialityReadOnlyNote: "قيم الأهمية النسبية تُقرأ من النموذج 105(a) — المصدر الوحيد. عدّلها في نموذج 105(a) الأهمية النسبية.",
      generalTitle: "تقييم المخاطر العام \u2066(ISA 315)\u2069",
      aiSuggestBtn: "اقتراح مخاطر بالذكاء الاصطناعي",
      aiSuggestHint: "يقترح المساعد مخاطر بناءً على ميزان المراجعة وبنود المالية. راجِع كل صف ثم اضغط \u201Cقبول\u201D لإضافته إلى السجل.",
      aiSuggestEmpty: "لم يُرجع المساعد أي مخاطر مقترحة لهذه المهمة.",
      aiSuggestAccept: "قبول",
      aiSuggestAcceptAll: "قبول الكل",
      aiSuggestDiscard: "تجاهل",
      aiSuggestLoading: "جاري اقتراح المخاطر…",
      aiSuggestFailedMsg: "فشل اقتراح الذكاء الاصطناعي. حاول مرة أخرى.",
      aiSuggestConfidence: "الثقة",
      aiSuggestSource: "المصدر",
      aiSuggestStatus: "الحالة",
      aiSuggestEmptyTb: "لا يوجد ميزان مراجعة محمّل لهذه المهمة، فلا توجد بيانات لاقتراح المخاطر منها. ارفع ميزان المراجعة أولاً.",
      aiSuggestQueued: "تم إرسال الطلب — جاري صياغة المخاطر من ميزان المراجعة ومخاطر السنة السابقة ومكتبة الإجراءات…",
      riskLibraryBtn: "مكتبة المخاطر",
      aiSuggestEdit: "تعديل", aiSuggestReject: "رفض", aiSuggestEditTitle: "تعديل المسودة قبل القبول",
      aiSuggestAcceptSave: "قبول في السجل", aiSuggestLinked: "الإجراءات المرتبطة",
      riskLibraryHint: "مخاطر ISA 315 القياسية (غير مولَّدة لهذه المهمة). راجِع كل صف ثم اضغط \u201Cقبول\u201D لإضافته إلى السجل.",
      addRisk: "إضافة خطر",
      fsArea: "بند القوائم المالية",
      assertion: "التأكيد",
      riskDesc: "وصف الخطر",
      inherent: "المتأصل",
      control: "الرقابي",
      likelihood: "الاحتمالية",
      impact: "الأثر",
      overallRating: "التقييم الإجمالي",
      response: "الاستجابة المخططة",
      fraudTitle: "بصمات مخاطر الاحتيال \u2066(ISA 240)\u2069",
      fraudDesc: "يتم فحصها تلقائياً عبر أستاذ الفترة الحالية. كل نتيجة هي نمط مؤشر تحذيري — راجع ما إذا كان مبرراً أم يحتاج مزيداً من العمل التدقيقي.",
      cutoffTitle: "اختبار الفصل الزمني — أول 5 وآخر 5 قيود",
      cutoffDesc: "قيود منتقاة تلقائياً حول نهاية الفترة \u2066(ISA 315)\u2069. اختبرها للتأكد من الاعتراف في الفترة الصحيحة.",
      first: "أول 5 قيود",
      last: "آخر 5 قيود",
      tabs: {
        materiality: "الأهمية النسبية",
        general: "المخاطر العامة \u2066(ISA 315)\u2069",
        fraud: "مخاطر الاحتيال \u2066(ISA 240)\u2069",
        cutoff: "الفصل الزمني",
      },
      tableEmpty: "لا توجد بنود مخاطر بعد. أضف أول خطر وفقاً لـ ISA 315 لبناء التقييم.",
      edit: "تعديل",
      saveRisk: "حفظ الخطر",
      editRisk: "تعديل الخطر",
      saveChanges: "حفظ التغييرات",
      attachLabel: "المستندات الداعمة لهذا البند من المخاطر",
      linkedProceduresLabel: "الإجراءات التدقيقية المرتبطة",
      linkedProceduresHelp: "اختر إجراءً أو أكثر من مكتبة إجراءات هذه المهمة للاستجابة لهذا الخطر. تُقترح الإجراءات مسبقاً بناءً على بند القوائم المالية.",
      linkedProceduresNone: "لا توجد إجراءات مرتبطة",
      linkedProceduresSuggested: "مقترحة لـ {area}",
      linkedProceduresAll: "جميع الإجراءات",
      linkedProceduresCount: "\u2066{n}\u2069 إجراء مرتبط",
      linkedProceduresPickBtn: "ربط الإجراءات",
      linkedProceduresEmpty: "مكتبة الإجراءات لا تحتوي على أي بنود لهذه المهمة.",
      linkedProceduresLoadError: "تعذر تحميل مكتبة الإجراءات.",
      refColLinked: "الإجراءات المرتبطة",
      bin: {
        title: "سلة المحذوفات",
        subtitle: "تبقى العناصر \u206630\u2069 يومًا والارتباطات \u206660\u2069 يومًا؛ تُستثنى الارتباطات المقفلة.",   // Batch 16 · Q12: each rule said once
        engagementWindow: "الحذف النهائي لارتباط: شريك الشركة أو مديرها أو المسؤول؛ خلال 30 يومًا من الحذف رمز لمرة واحدة إلى بريدك مع كتابة اسم الارتباط، وبعد 30 يومًا الاسم المكتوب فقط. يُحفظ كل حذف نهائي في سجل التدقيق.",
        permanent: "حذف نهائي", permanentTitle: "حذف هذا الارتباط نهائيًا؟",
        permanentBody: "{name} · {days} يوم في السلة. لا يمكن التراجع. اكتب اسم الارتباط للتأكيد.",
        permanentOtp: "سيُرسل رمز لمرة واحدة إلى بريدك (حُذف الارتباط قبل أقل من 30 يومًا).",
        permanentNoOtp: "أكثر من 30 يومًا في السلة — يكفي الاسم المكتوب.",
        permanentConfirm: "حذف نهائي", permanentDone: "حُذف الارتباط نهائيًا", permanentNameMismatch: "اكتب اسم الارتباط كما هو معروض تمامًا.",   // Batch 14 · M16
        colType: "النوع", colName: "الاسم / المرجع", colEng: "المهمة",
        colDeletedBy: "حذفه", colDeletedAt: "متى",
        colReason: "السبب", colDaysLeft: "الأيام المتبقية",
        colActions: "",
        restore: "استعادة",
        restoreOk: "تمت الاستعادة",
        restoreFail: "فشلت الاستعادة",
        empty: "سلة المحذوفات فارغة.",
        tabDeleted: "العناصر المحذوفة",
        tabArchived: "المهام المؤرشفة",
        restoreForbidden: "لا يمكن الاستعادة إلا للشريك / المدير التنفيذي / المدير / المسؤول.",
        windowDays: "\u2066{n}\u2069 نافذة أيام",
        purgeDryRun: "المنظّف اليومي في وضع التجربة: لا يُحذف شيء بعد؛ تبقى العناصر التي تجاوزت مدتها مخفية حتى تفعيل المنظّف.",
        purgeActive: "يحذف المنظّف اليومي العناصر عند انتهاء مدتها.",
        daysLeftRule: "الأيام المتبقية = جزء صحيح (المدة − الوقت منذ الحذف). عند 0 يُزيل المنظّف اليومي العنصر.",
        type: {
          attachment: "مرفق",
          risk: "عنصر سجل المخاطر",
          misstatement: "تحريف",
          w17_likely_area: "منطقة محتملة \u2066(W17)\u2069",
          gl_head_upload: "رفع أستاذ عام للرأس",
          vouching_work_done_line: "سطر عمل المطابقة",
          vouching_items: "سطر مطابقة",
          engagement_archived: "مهمة مؤرشفة",
          engagement: "ارتباط (محذوف)",
          form_state: "إجابات النموذج",
          sample: "عينة",
          deficiency: "قصور رقابة",
          form_attachment: "ملف داعم",
          unknown: "آخر",
        },
      },
      procRisks: {
        title: "المخاطر التي يستجيب لها هذا الإجراء",
        empty: "لا يوجد خطر مرتبط بهذا الإجراء حتى الآن.",
        noLinked: "لا يوجد خطر مرتبط",
      },
      refreshing: "جاري التحديث…",
      refresh: "تحديث",
      refreshBold: "تحديث",
      scanning: "جاري الفحص…",
      fraudRunning: "جاري تشغيل فحص بصمة الاحتيال عبر أستاذ الفترة الحالية…",
      fraudLoadError: "تعذر تحميل فحص الاحتيال",
      fraudRetryHint: "انقر {refreshBold} أعلاه للمحاولة مرة أخرى.",
      fraudEmptyTitle: "لا توجد قيود أستاذ لفحصها",
      fraudEmptyBody: "لا تحتوي هذه المهمة على قيود أستاذ للفترة الحالية. استورد أستاذاً من {linkItalic} لتشغيل بصمات الاحتيال.",
      fraudEmptyLink: "العمل الميداني ← استيراد الأستاذ",
      dataQualityNotes: "ملاحظات جودة البيانات",
      largeResultSetBold: "مجموعة نتائج كبيرة —",
      largeResultSetBody: "تجاوزت بعض البصمات الحد الأقصى للتخزين المؤقت (500 صف) وتعرض أول {n} نتيجة. لا تزال شارات العدّ تعكس الإجمالي الفعلي. استخدم تصدير XLSX لأي مجموعة لتنزيل جميع الصفوف المُعلَّمة.",
      populationLabel: "المجتمع:",
      populationSuffix: "قيود أستاذ للفترة الحالية",
      cappedTitle: "تم تقييد العدد ليساوي حجم المجتمع — لا يمكن أن تتجاوز البصمة إجمالي قيود الأستاذ.",
      cappedBadge: "مقيّد",
      cutoffCardTitle: "الفصل الزمني (ISA 315) — الأول/الأخير",
      cutoffCacheEmpty: "لا يوجد فحص فصل زمني مخزّن بعد. انقر تحديث لتشغيله على أسطول العمّال.",
      cutoffRunning: "جاري تشغيل فحص الفصل الزمني على أسطول العمّال…",
      cutoffCached: "مخزّن",
      cutoffStale: "(قديم — تغيّر الأستاذ)",
      showingPre: "عرض",
      showingMid: "من",
      showingSuffix: "معاملة معلَّمة",
      truncatedByServer: "— اقتُطعت القائمة من الخادم",
      colDate: "التاريخ",
      colVoucherAccount: "السند / الحساب",
      colAmount: "المبلغ",
      colReason: "السبب",
      colVoucher: "السند",
      colAccount: "الحساب",
      noVoucher: "(بدون سند)",
      openGlEntryTitle: "افتح قيد الأستاذ في تبويب جديد",
      testTheseNow: "اختبر هذه الآن",
      testTheseNowTitle: "افتح العينات مع تحديد الاختبار المستمر مسبقاً لهذه البصمة",
      downloadXlsxTitle: "تنزيل جميع {n} معاملة معلَّمة كملف XLSX",
      exportSuccess: "تم تصدير {n} معاملة معلَّمة",
      exportFailed: "فشل التصدير",
      selectEngFirst: "اختر المهمة أولاً",
      toasts: {
        fraudAlreadyRunning: "يعمل بالفعل فحص احتيال لهذه المهمة — جاري الاستطلاع…",
        fraudQueued: "تم إدراج فحص الاحتيال في قائمة الانتظار — ستظهر النتائج قريباً.",
        fraudEnqueueFailed: "تعذر إدراج فحص الاحتيال.",
        fraudLoadFailed: "تعذر تحميل فحص الاحتيال.",
        cutoffAlreadyRunning: "يعمل بالفعل فحص فصل زمني لهذه المهمة — جاري الاستطلاع…",
        cutoffQueued: "تم إدراج فحص الفصل الزمني في قائمة الانتظار.",
        cutoffEnqueueFailed: "تعذر إدراج فحص الفصل الزمني.",
        materialitySaved: "تم حفظ الأهمية النسبية — تعرض العينات وكل شاشة مرتبطة هذه القيم الآن",
        saveFailed: "فشل الحفظ",
        riskAdded: "تمت إضافة الخطر",
        addFailed: "فشل",
        deleteFailed: "فشل الحذف",
        riskUpdated: "تم تحديث الخطر",
        updateFailed: "فشل التحديث",
      },
      nwd: {
        title: "أيام غير العمل (عطلات نهاية الأسبوع + العطل الرسمية)",
        desc: "تُغذي بصمة {weekendBold} هنا، وعلامات نهاية الأسبوع في التحليلات، ومُقيّم العينات المستند إلى المخاطر. لا يُعاد كتابة الفحوصات التاريخية — انقر {refreshBold} أعلاه لإعادة الفحص بعد الحفظ.",
        weekendBold: "نهاية الأسبوع / بعد ساعات العمل",
        refreshBold: "تحديث",
        weekendDays: "أيام نهاية الأسبوع",
        publicHolidays: "العطل الرسمية",
        noHolidays: "لم يتم تكوين أي عطلات.",
        cannotAllNonWorking: "لا يمكن اعتبار كل يوم غير عمل.",
        saved: "تم حفظ أيام غير العمل. انقر تحديث أعلاه لإعادة الفحص.",
        add: "إضافة",
        save: "حفظ",
        days: {
          mon: "الاثنين",
          tue: "الثلاثاء",
          wed: "الأربعاء",
          thu: "الخميس",
          fri: "الجمعة",
          sat: "السبت",
          sun: "الأحد",
        },
      },
    },
  },
};

export default I18N_BASE_RISK;
